module.exports = __webpack_public_path__ + "static/img/man_glove_3.404e7cb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/man_glove_3.png
// module id = cxLE
// module chunks = 0